import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block2() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center">
                        <div className="image-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/bureau.webp" alt="bureau" className="homepage"/>
                            </figure>
                        </div>

                        <div className="content-column col-xl-6 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Vos webinaires <span>clé en main</span></h2>
                                </div>
                                <div className="text">
                                    Nous concevons et animons pour vous des <b>webinaires clés en main</b>, portés par
                                    les <b>experts Talents Handicap</b>. Vous disposez d’un <b>espace web dédié</b> pour piloter,
                                    diffuser et valoriser <b>vos actions de sensibilisation</b>.

                                    <ul className="list-style-two homepage">
                                        <li>Organisation et animation des webinaires par nos experts</li>
                                        <li>Un espace web dédié à votre entreprise</li>
                                        <li>Accès au programme, inscriptions et replays</li>
                                        <li>Outils pour valoriser votre politique handicap et vos actions</li>
                                        <li>Kit de communication complet pour faciliter votre communication interne</li>
                                        <li>Suivi de la participation et de la satisfaction des participants</li>
                                    </ul>
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>*/}

                                <ContactModal textButton="En savoir plus sur l'espace dédié" showText={true} small="small"
                                              linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block2;
